export default __webpack_public_path__ + "./img/profile.073e06e32a5f4e369d91651969727de0.png";